import Swal from 'sweetalert2'
import moment from 'moment-timezone';

/*
** Converts UTC timestamp to local timezone and formats it
** @param {string} timestamp - UTC timestamp (e.g., "2025-02-12T07:01:19.000Z")
** @param {string} timezone - Timezone string (e.g., "Asia/Kolkata", "America/New_York")
*/
export const convertUTCToLocal = (timestamp, timezone) => {
  if (!timestamp) {
    return 'Invalid timestamp or timezone';
  }

  // Pages historically sourced `timezone` from localStorage, which no longer holds anything
  // since session data moved to httpOnly cookies. Fall back to the browser's own timezone —
  // the same value Login.js already detects and sends to the backend at login time — instead
  // of failing whenever no (or an invalid) timezone string is passed in.
  const resolvedTimezone = (timezone && moment.tz.zone(timezone))
    ? timezone
    : Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localTime = moment.utc(timestamp).tz(resolvedTimezone);
  return localTime.format('DD MMM, YYYY hh:mm A'); // Example: 12 Feb, 2025 - 12:31 PM
};

export function logOutRedirectCall(){
  // Called automatically on a 401/network error — the session is already invalid at this
  // point, so there's nothing valid left to tell the backend to invalidate (and calling
  // /logout here would itself 401 and re-trigger this same function). Just bounce to login.
  // Guard against reloading a page we're already on (would otherwise reload-loop).
  if (window.location.pathname.includes('/login')) {
    return;
  }
  window.location.href = '/authpanel/login';
}

export async function logoutConfirmation() {
  // Show confirmation dialog
  const result = await Swal.fire({
      title: "",
      text: `Are you sure you want to sign out?`,
      imageUrl: process.env.PUBLIC_URL + '/logo.png',
      imageSize: '80x80',
      showCancelButton: true,
      confirmButtonColor: "#B6A878",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign out",
  });
  if (result.isConfirmed) {
    const { logout } = await import('../../api/apiHandler');
    await logout({});
    showMessage("Sign out successfully");
    window.location.href = '/authpanel/login';
  }
}

export const showMessage = (msg) => {
  Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: msg,
      toast: true,
      showConfirmButton: false,
      timer: 5000
  })
}

export const showErrorMessage = (msg) => {
  Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: msg,
      toast: true,
      showConfirmButton: false,
      timer: 5000
  })
}